import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

// import { useImageBorderStyles } from '@vestico/shared';
import style from './PreviewText.module.css';

export interface PreviewTextProps {
  userName?: string;
  content?: string;
  // borderRadius: string[];
  isOverlay?: boolean;
}

export const PreviewText = ({ userName, content, isOverlay }: PreviewTextProps) => {
  const { t } = useTranslation('shared');

  const showAnyContent = content !== undefined;
  const hasContentText = content && content.length > 0;
  const userNameContent = userName ? <span className={clsx(style.content, style.user, { [style.preview]: !hasContentText })}>{userName}</span> : null;
  const firstLineContent = userNameContent && hasContentText ? userNameContent : null;
  const secondLineContent = hasContentText ? <span className={clsx(style.content, style.preview)}>{content}</span> : userNameContent;
  // const containerStyle = useImageBorderStyles(borderRadius);

  return showAnyContent ? (
    <div className={clsx(style.root, { [style.overlay]: isOverlay })}>
      {firstLineContent ? <div className={clsx(style.contentWrapper)}>{firstLineContent}</div> : null}
      <div className={clsx(style.contentWrapper)}>
        {secondLineContent ?? <span />}
        <span className={clsx(style.content, style.moreBtn)}>{t('LOC_PREVIEW_MORE_BUTTON', { ns: 'shared' })}</span>
      </div>
    </div>
  ) : null;
};
